import { toast } from "sonner";
import { debugWarn } from "./debug";

export interface BackendDocumentRef {
  _id?: string;
  id?: string;
  title?: string;
}

/**
 * Backend GET /documents returns `_id`. Some payloads also expose `id`.
 * Feature APIs (chat, Compass, reviews) must use this backend id, not the
 * Word custom-property GUID.
 */
export function getBackendDocumentId(
  doc: BackendDocumentRef | null | undefined
): string | undefined {
  if (doc == null) return undefined;
  const fromUnderscore = doc._id?.trim();
  if (fromUnderscore != null && fromUnderscore !== "") return fromUnderscore;
  const fromId = doc.id?.trim();
  if (fromId != null && fromId !== "") return fromId;
  return undefined;
}

export function getDocumentTitle(doc: BackendDocumentRef | null | undefined): string {
  const title = doc?.title?.trim();
  return title != null && title !== "" ? title : "Untitled Document";
}

export function notifyDocumentNotReady(area: string): void {
  debugWarn(area, "blocked: document id missing");
  toast.error("Document isn't ready", {
    description: "Quillio is still linking this Word file. Wait a moment and try again.",
  });
}
